import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M16.0003 7.5C16.0003 7.22386 16.2242 7 16.5003 7C16.7765 7 17.0003 7.22386 17.0003 7.5C17.0003 7.72205 16.8432 8.04533 16.5123 8.40726L16.5004 8.42026L16.4884 8.40723C16.1574 8.04524 16.0003 7.72197 16.0003 7.5Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M8.00034 10.5C8.00034 10.2239 8.2242 10 8.50034 10C8.77649 10 9.00034 10.2239 9.00034 10.5C9.00034 10.722 8.84323 11.0453 8.51231 11.4073L8.50037 11.4203L8.48839 11.4072C8.15744 11.0452 8.00034 10.722 8.00034 10.5Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 2V22H2V2H22ZM16.3129 10.8359C16.3755 10.8784 16.4381 10.9208 16.5003 10.9636C16.5625 10.9208 16.6251 10.8784 16.6877 10.836C16.9203 10.6783 17.1532 10.5205 17.3701 10.342C17.5367 10.2049 17.761 10.0055 17.9884 9.7568C18.4075 9.29842 19.0003 8.4967 19.0003 7.5C19.0003 6.11929 17.8811 5 16.5003 5C15.1196 5 14.0003 6.11929 14.0003 7.5C14.0003 8.49664 14.5932 9.29837 15.0123 9.75673C15.2397 10.0054 15.4639 10.2049 15.6305 10.3419C15.8475 10.5205 16.0803 10.6783 16.3129 10.8359ZM8.30186 13.8287C8.36818 13.8735 8.43447 13.9183 8.5003 13.9636C8.56616 13.9183 8.63246 13.8735 8.69879 13.8287C8.85508 13.7232 9.01151 13.6176 9.1625 13.505C9.21479 13.466 9.2861 13.4111 9.37014 13.342C9.53672 13.2049 9.76099 13.0055 9.98837 12.7568C10.4075 12.2984 11.0003 11.4967 11.0003 10.5C11.0003 9.11929 9.88106 8 8.50034 8C7.11963 8 6.00034 9.11929 6.00034 10.5C6.00034 11.4966 6.59324 12.2984 7.0123 12.7567C7.23968 13.0054 7.46394 13.2049 7.63051 13.3419C7.71455 13.4111 7.78585 13.466 7.83814 13.505C7.98914 13.6176 8.14557 13.7232 8.30186 13.8287ZM13.9151 15.7875L19.7878 13.5852L19.0855 11.7125L13.2129 13.9148L13.9151 15.7875ZM5.91514 18.7875L11.7878 16.5852L11.0855 14.7125L5.21289 16.9148L5.91514 18.7875Z"}}]};

const MapDistanceFilled = Vue.extend<IconProps>({
  name: 'MapDistanceFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'map-distance-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default MapDistanceFilled;
